/**
 * bc-maul (พยัคฆ์กดเหยื่อ, the tongs-claw lock routine) live: the hand-made routine (sampleArt/arts/bloodclaw.ts `maul`)
 * timed to the rules' beats (packages/shared data/longMoves/bloodClaw.ts) instead of its page clock, the way
 * fx/longMoon.ts does ms-kiss: the heat over the lock wind-up, the pounce, the mount, the two rakes, the flurry, the
 * roll, the roar, the upward tear, the fall. The afterimages come from the beats' `ai` (render/longMove.ts), so the
 * sample's own are left out.
 */
import { longMoveOf } from '@nine/shared';
import { longRetime } from '../longMove';
import { registerFx } from './registry';
import { portOf } from './sampleArt/port';
import { BLOODCLAW_MAUL_T as T } from './sampleArt/arts/bloodclaw';

registerFx([], (host) => {
  const def = longMoveOf('bc-maul');
  const spec = portOf('bc-maul');
  if (!def || !spec) return {};
  const at = (pose: string): number => def.beats.find((b) => b.pose === pose)?.at ?? -1;
  const marks = [at('bcPounce'), at('bcMount'), at('bcRakeL'), at('bcRakeR'), at('bcRakeFlurry'), at('bcFlip'), at('bcRoar'), at('bcRendUp'), at('bcCrouch'), at('bcStance')];
  if (marks.some((x) => x < 0)) return {};
  const anchors: [number, number][] = [
    [-(def.catch ?? 0.45), 0.05],
    [marks[0]!, T.start],
    [marks[1]!, T.mount],
    [marks[2]!, T.rake[0]],
    [marks[3]!, T.rake[1]],
    [marks[4]!, T.flurry],
    [marks[5]!, T.flip],
    [marks[6]!, T.roar],
    [marks[7]!, T.rend],
    [marks[8]!, T.fall],
    [marks[9]!, T.stance],
    [def.len, T.end],
  ];
  spec.ghosts = undefined;
  spec.retime = longRetime(host.world, 'bc-maul', anchors, T.end);
  return {};
});
